<template>
    <section class="caratandquantity">
        <div class="caratModal" v-if="['weight1', 'weight2'].includes(boxValue)">

            <div class="title_block">
                <h3 class="mb-0 font-active">{{ titleDivide }} :
                    <span v-if="props?.detailData?.sub_type === 'hues-ring' || props?.detailData?.sub_type === 'soiree-ring'">
                        <span>{{ weightData && weightData.includes(' tw.') ? weightData : (weightData ?
                        weightData + ' tw.' : '') }}</span>
                    </span>
                    <span v-else>{{ weightData && weightData.includes('ct. tw.') ? weightData : (weightData ?
                        weightData + ' ct. tw.' : '') }}</span>
                </h3>

                
            </div>
            <div class="mt-3">
                <div class="image_block my-3 text-center">
                    <img src="/settingactive/totalctwt.svg" width="150" height="72">
                    <p v-if="props?.detailData?.sub_type === 'hues-ring' || props?.detailData?.sub_type === 'soiree-ring'">
                        {{ weightData?.includes(' Tw.') ? weightData : weightData + '  Tw.' }}
                    </p>
                    <p class="mb-0 title" v-else>{{ weightData?.includes('ct. tw.') ? weightData : weightData + ' ct. tw.' }}
                    </p>
                </div>
                <p v-for="paragraph in paragraphs" :key="paragraph" class="mb-0">
                    {{ paragraph }}
                </p>
            </div>

        </div>

        <div class="quantityModal" v-if="['sidestone', 'quantity'].includes(boxValue)">
            <div class="">

                <div class="title_block">
                    <h3 class="mb-0 font-active">{{ quantityTitle }}</h3>

                </div>

                <div class="mt-3 text-center">
                    <div class="image_block my-3">
                        <img v-for="(imageName, index) in imageNames" :key="index" width="115" height="72"
                            :src="`/settingactive/${imageName}.svg`" :alt="imageName" />
                    </div>
                    <!-- <p class="mb-0" v-if="resolvedQuantity">Quantity : <b>{{ resolvedQuantity }}</b></p> -->
                    <div class="text-center shape_block">
                        <p v-if="props?.boxValue === 'quantity' || resolvedQuantity" class="mb-0">
                            Quantity: <b>{{ resolvedQuantity }}</b>
                        </p>
                        <div v-else class="mb-0">
                            <p class="mb-0" v-if="resolvedQuantity">Quantity : <b>{{ resolvedQuantity }}</b></p>
                        </div>
                        <p class="mb-0" v-if="showShape">
                            Shape : <b>{{ item?.side_stone_shape }}</b>
                        </p>
                       
                        <!-- <p v-if="props?.detailData.sub_type === 'hues-ring'" class="mb-0">
                            Shape: <b>{{ item?.center_normal_stone_shape|| item?.side_normal_stone_shape || item?.center_color_stone_shape}}</b>
                        </p> -->

                        <p class="mb-0 hues_mew" v-if="isRingType">
                            Shape: <b>{{ uniqueShapes.join(', ') }}</b> 
                        </p>



                        <p v-if="displayShape" class="mb-0">
                            Shape :
                            <span
                                v-if="currentMetal?.side_stone_shape?.toLowerCase() === currentMetal?.shape?.toLowerCase()">
                                <b>{{ currentMetal?.shape }}</b>
                            </span>
                            <span v-else>
                                <span v-if="currentMetal?.shape">
                                    <b>{{ sanitizedShape }}</b><span v-if="currentMetal?.side_stone_shape">, </span>
                                </span>
                                <span v-if="currentMetal?.side_stone_shape">
                                    <b>{{ currentMetal?.side_stone_shape }}</b>
                                </span>
                            </span>
                        </p>
                    </div>
                    <p class="mt-2 mb-0 text-start" v-if="diamondQuantityText">Diamond quantity refers to the total
                        number of diamonds
                        featured in a {{ $t('jewelry') }} piece, including the smaller accent stones.
                    </p>
                    <p class="mt-2 mb-0 text-start" v-else-if="isDiamondQuantitySubType">Diamond quantity refers to the
                        total number of diamonds
                        featured in a {{ $t('jewelry') }} piece, including the smaller accent stones.
                    </p>
                    <p class="mt-2 mb-0 text-start" v-else-if="isRingType">
                        Diamond quantity refers to the total number of diamonds featured in a jewelry piece.
                    </p>
                    <p class="mt-2 mb-0 text-start" v-else>Accent diamonds are smaller diamonds that are placed around
                        or next to the centerstone in a {{ moduleSubType }} to enhance its look. The number and shape of
                        these side stones can enhance the look of a design.</p>
                </div>
                <div class="soiree_text" v-if="isRingType && fancysubtypes !== 'soiree-earring'">
                    <p class="mt-1 mb-0 text" v-if="$country.is_india">
                        *Shown as per ring size IN 14. The number of accent diamonds may vary according to the selected ring
                        size.
                    </p>

                    <p class="mt-1 mb-0 text" v-if="!$country.is_india">
                        *Shown as per ring size US 7. The number of accent diamonds may vary according to the selected ring
                        size.
                    </p>

                </div>

                <p class="mt-1 mb-0 text" v-if="showDefaultText">
                    *The number of accent diamonds may vary as per the carat weight of the center diamond.
                </p>

                <p class="mt-1 mb-0 text" v-if="braceletNote">
                    *The number of diamonds may vary as per the total carat weight and the bracelet length.
                </p>
                <p class="mt-1 mb-0 text" v-if="necklaceNote">
                    *The number of diamonds may vary as per the total carat weight and the necklace length.
                </p>


                <p class="mt-1 mb-0 text" v-if="showSolitaireNecklaceText">
                    *The number of diamonds may vary as per the total carat weight.
                </p>

                <!-- For Preset Only  -->
                <p class="mt-1 mb-0 text" v-if="isPreset">
                    *The number of accent diamonds may vary as per the ring size and the carat weight of the
                    centre diamond.
                </p>

                <!-- dynamic below for eternity -->
                <p class="mt-1 mb-0 text" v-if="showIndiaEternityText">
                    *Shown as per ring size IN 14. The number of diamonds may vary according to the
                    {{ detailData?.category }} size and the total carat weight selected.
                </p>

                <p class="mt-1 mb-0 text" v-if="showNonIndiaEternityText">
                    *Shown as per ring size US 7. The number of diamonds may vary according to the
                    {{ detailData?.category }} size and the total carat weight selected.
                </p>

                <!-- wedding band only -->
                <p class="mt-1 mb-0 text" v-if="showWeddingBandText">
                    *The number of accent diamonds may vary according to the {{ detailData?.category }} size.
                </p>

                <p class="mt-1 mb-0 text" v-if="isHoopEarring">
                    *The number of accent diamonds may vary as per total carat weight.
                </p>
            </div>
        </div>

        <div v-if="['fancyNormalQ'].includes(boxValue)">
            <div class="title_block">
                <h3 class="mb-0 font-active">{{ quantityTitle }}</h3>

            </div>
            <div class="text-center">
                <div class="image_block my-3">
                    <img v-for="(imageName, index) in imageNames" :key="index" width="115" height="72"
                        :src="`/settingactive/${imageName}.svg`" :alt="imageName" />
                        
                </div>

                <p class="mb-0">Quantity : <b> {{ item?.side_normal_stone_num_lots }}</b></p>
                <p v-if="props?.boxValue === 'fancyNormalQ'" class="mb-0">
                    Shape: <b>{{ item?.side_normal_stone_shape }}</b></p>

            </div>
            <p class="mt-2 mb-0 text-start">Diamond quantity refers to the total number of diamonds
                featured in a {{ $t('jewelry') }} piece.
            </p>
            <p class="text mb-0" v-if="detailData.sub_type === 'soiree-ring'">
                *Shown as per ring size US 7. The number of diamonds may vary according to the ring size
            </p>


        </div>

    </section>
</template>

<script setup>

const props = defineProps(['item', 'currentCarat', 'caratBox', 'caratData', 'detailData', 'currentMetal', 'addtionalAttirbute', 'boxValue', 'presetsubtype', 'moduleSubType', 'complete']);
// console.log(props, 'moduleSubType');
const route = useRoute();
const { $country } = useNuxtApp()
const presetsubtype = props?.presetsubtype;
const ringsubtype = props?.moduleSubType;
// console.log(presetsubtype, '[reser]', 'side_stone?.diamonds');
const fancysubtypes = props?.detailData?.sub_type || props?.detailData?.subType || route.params.type;
// console.log(fancysubtypes,'sadasdsa');

const imageNames = ref([]);
// console.log(route.params.type,'complete',route?.meta?.name);


const subType = route?.params?.type;
// console.log(subType, 'asd');

const weightData = computed(() => {
    if (props?.boxValue === 'weight1' && (fancysubtypes === 'hues-ring' || fancysubtypes === 'soiree-ring' )) {
        // console.log('Weight 1:', props.currentCarat?.value, props?.item?.side_stone?.carat, props?.item.center_normal_stone_lot_weight);
        return props?.item?.side_stone?.carat || props?.currentCarat?.label  || '';
    }
    if(props?.boxValue === 'weight1'){
        return props?.item?.side_stone?.carat || props?.currentCarat?.value || ''; 
    }
    if (props?.boxValue === 'weight2') {
        // console.log('Weight 2:', props?.currentCarat?.lot_weight, props?.side_normal_stone_lot_weight);
        return props?.currentCarat?.lot_weight || props?.item.side_normal_stone_lot_weight;
    }
    return null;
});

const minTotalCaratTypes = [
    'eternity-rings',
    'toi-et-moi-engagement-rings',
    'anniversary-rings',
    'tennis-bracelet',
    'fashion-bracelets',
    'fashion-earrings',
    'openable-bangle',
    'stud-earrings',
    'hoop-earrings',
    'tennis-necklace',
    'solitaire-necklace',
    'womens-wedding-rings',
    'couple-rings',
    'fashion-necklaces',
    'initial-necklaces'
];
const sideStoneQuantity = ['ready-to-ship-engagement-rings'];
const accentStone = ['preset', 'earring', 'pendant','openable-bangle'];
const fancy = ['hues-ring', 'soiree-ring', 'soiree-earring', 'roses-portraits-ring','initial-necklaces'];
const ringstone = ['ring', 'earring', 'pendant', 'cyo-complete-earring'];

const titleDivide = computed(() => {
    if (ringstone?.includes(ringsubtype || route?.meta?.name)) {
        return 'Total Carat Weight'
    }
    else if (accentStone?.includes(presetsubtype)) {
        return 'Accent Carat Weight'
    }
    // else if (fancy?.includes(fancysubtypes)){
    //     return 'Diamond Quantity & Shape'
    // }
    return minTotalCaratTypes?.includes(subType) ? 'Min. Total Carat Weight' : 'Total Carat Weight';
});

const quantityTitle = computed(() => {
    // console.log(quantityTitle, 'dsa');
    if (sideStoneQuantity?.includes(subType)) {
        return 'Side Stone Quantity & Shape';
    }
    else if (fancy?.includes(fancysubtypes)) {
        return 'Diamond Quantity & Shape'
    }
    if (accentStone?.includes(props?.moduleSubType)) {
        return 'Accent Stone Quantity & Shape'
    }
    return minTotalCaratTypes?.includes(subType) ? 'Diamond Quantity & Shape' : 'Side Stone Quantity & Shape'

})

const paragraphs = computed(() => {
    const jewelryTerm = $country.is_india ? 'jewellery' : 'jewelry';

    if (titleDivide?.value === 'Min. Total Carat Weight') {
        return [
            `“Minimum total carat” refers to the total carat weight of all the diamonds featured in a ${jewelryTerm} piece, including the smaller accent stones.`
        ];
    }
    if (titleDivide?.value === 'Total Carat Weight') {
        if (fancy?.includes(fancysubtypes) && (fancysubtypes === 'hues-ring' || fancysubtypes === 'soiree-ring' || fancysubtypes === 'soiree-earring')) {
            return [
                `Total carat refers to the minimum total carat weight of all the diamonds featured in a ${jewelryTerm} piece.`
            ];
        }
        return [
            `Total carat refers to the total carat weight of all the diamonds featured in a ${jewelryTerm} piece.`
        ];
    }
    if (titleDivide?.value === 'Accent Carat Weight') {
        return [
            `Accent carat weight refers to the total carat weight of all the accent diamonds featured in a ${jewelryTerm} piece, excluding the center diamond weight.`
        ];
    }
});
const diamondQuantitySubTypes = [
    'band-ring',
    'hoop-earring',
    'solitaire-necklace',
    'tennis-bracelet',
    'openable-bangle',
    'tennis-necklace',
    'fashion-necklace',
    'fashion-bracelet',
    'fashion-earring',
    'stud-earring',
    'couple-bands-ring',
    'toi-et-moi-ring',
    'full-eternity-ring',
    'anniversary-ring',
    'roses-portraits-ring',
    'initial-necklace'
];
const diamondQuantityText = computed(() => {
    return props?.presetsubtype === 'preset' || props?.detailData?.sub_type === 'in-stock-ring';
});
const isDiamondQuantitySubType = computed(() =>
    diamondQuantitySubTypes.includes(props?.detailData?.sub_type)
);
const sortHuesOrSoireeRingsImages = () => {
    imageNames.value = uniqueShapes.value;
};
const sanitizedShape = computed(() => {
    const shape = props?.currentMetal?.shape;
    if (!shape) return "";

    return shape
        .split(/[\s,]+/) // Split by commas or spaces
        .map(name => name.toLowerCase().replace(/[\s-]+/g, '').trim()) // Normalize names
        .filter((name, index, arr) => arr.indexOf(name) === index) // Remove duplicates
        .map(name => name.charAt(0).toUpperCase() + name.slice(1)) // Capitalize first letter
        .join(", "); // Join back to a string
});
const braceletNote = computed(() => {
    return props?.detailData?.sub_type === 'tennis-bracelet' || props?.detailData?.sub_type === 'fashion-bracelet';
});

const necklaceNote = computed(() => {
    return props?.detailData?.sub_type === 'solitare-necklace' || props?.detailData?.sub_type === 'tennis-necklace' || props?.detailData?.sub_type === 'fashion-necklace' || route.params.type === 'initial-necklaces';
});
const sortMultipleImages = () => {
    const shape = props?.currentMetal?.shape || '';
    const sideStoneShape = props?.currentMetal?.side_stone_shape || '';

    // Combine shapes into one string and split by commas or spaces
    const combinedShapes = `${shape},${sideStoneShape}`;

    imageNames.value = combinedShapes
        .split(/[\s,]+/)  // Split by spaces or commas
        .map(name => name.toLowerCase().trim())  // Normalize shape names
        .filter(name => name)  // Remove empty values
        .filter((name, index, arr) => arr.indexOf(name) === index);  // Remove duplicates

};


const sortSingleImage = () => {
    const sideStoneShapes = [
        props?.currentMetal?.side_stone_shape || '',
        props?.item?.side_stone_shape || props?.item?.side_normal_stone_shape || ''
    ];

    imageNames.value = sideStoneShapes
        .flatMap(shape => shape.split(/[\s,]+/))  // Split by spaces or commas
        .map(name => name.toLowerCase().replace(/[\s-]+/g, '').trim())  // Normalize shape names
        .filter((name, index, arr) => arr.indexOf(name) === index && name !== '');  // Remove duplicates and empty strings

};


const showShape = computed(() => {
    const validSubtypes = ['preset', 'ring', 'earring', 'pendant'];
    return validSubtypes.includes(props?.moduleSubType) || presetsubtype === 'preset' || route?.meta?.name === 'cyo-complete-earring' || route?.meta?.name === 'cyo-complete-ring' || route?.meta?.name === 'cyo-complete-ring'
        || route.meta.name === 'cyo-complete-pendant' || route?.params?.type === 'ready-to-ship-earrings';
});
const sortFancynormalQImages = () => {
    // Extract shapes for 'fancyNormalQ' case
    const shapes = [
        props?.item?.side_normal_stone_shape || ''
    ]
        .filter(value => value.trim())  // Ensure non-empty shapes
        .flatMap(shape => shape.split(/[\s,]+/))  // Split by commas or spaces
        .map(name => name.toLowerCase().replace(/[\s-]+/g, '').trim())  // Normalize shape names
        .filter((name, index, arr) => arr.indexOf(name) === index);  // Remove duplicates

    imageNames.value = shapes;  // Set the image names for 'fancyNormalQ'
};

const sortWeight2Images = () => {
    // Extract shapes for 'weight2' case
    const shapes = [
        props?.item?.center_normal_stone_shape || ''
    ]
        .filter(value => value.trim())  // Ensure non-empty shapes
        .flatMap(shape => shape.split(/[\s,]+/))  // Split by commas or spaces
        .map(name => name.toLowerCase().replace(/[\s-]+/g, '').trim())  // Normalize shape names
        .filter((name, index, arr) => arr.indexOf(name) === index);  // Remove duplicates

    imageNames.value = shapes;  // Set the image names for 'weight2'
};

const sortImages = () => {
    // Handle images based on boxValue
    if (props?.boxValue === 'fancyNormalQ') {
        sortFancynormalQImages();
    } else if (props?.boxValue === 'weight2') {
        sortWeight2Images();
    } else {
        // Default image sorting logic
        const multipleImageSubTypes = [
            'toi-et-moi-ring',
            'tennis-bracelet',
            'couple-bands-ring',
            'hoop-earring',
            'stud-earring',
            'fashion-earring',
            'tennis-necklace',
            'solitaire-necklace',
            'full-eternity-ring',
            'anniversary-ring',
            'band-ring',
            'fashion-bracelet',
            'openable-bangle',
            'fashion-necklace',
            'roses-portraits-ring',
            'initial-necklace'
        ];

        // If it's a hues-ring or soiree-ring, sort with the specific method for multiple shapes
        if (['hues-ring', 'soiree-ring','soiree-earring'].includes(props?.detailData?.sub_type)) {
            sortHuesOrSoireeRingsImages();
        }
        // For multiple images (side stone + main stone shapes)
        else if (multipleImageSubTypes?.includes(props?.currentMetal?.sub_type || props?.detailData?.sub_type)) {
            sortMultipleImages();
        }
        // Default case for single image (e.g., side stone shape only)
        else {
            sortSingleImage();
        }
    }
};

const displayShape = computed(() => {
    const subTypeList = [
        'toi-et-moi-ring',
        'full-eternity-ring',
        'anniversary-ring',
        'couple-bands-ring',
        'tennis-bracelet',
        'fashion-bracelet',
        'openable-bangle',
        'fashion-necklace',
        'stud-earring',
        'hoop-earring',
        'tennis-necklace',
        'solitaire-necklace',
        'fashion-earring',
        'band-ring',
        'in-stock-ring',
        'in-stock-pendant',
        'soiree-ring',
        'hues-ring',
        'roses-portraits-ring',
        'initial-necklace'
    ];
    if (subTypeList === 'soiree-earring') {
        return fancysubtypes?.includes(subTypeList);
    }
    const subType = props?.currentMetal?.sub_type;
    return subType && subTypeList?.includes(subType);
});
// || props?.detailData.sub_type
const showDefaultText = computed(() => {
    return !(props?.currentMetal?.sub_type || props?.detailData?.sub_type || props?.detailData?.subType && [
        'toi-et-moi-ring',
        'solitaire-necklace',
        'full-eternity-ring',
        'couple-bands-ring',
        'band-ring',
        'hoop-earring',
        'anniversary-ring',
        'stud-earring',
        'fashion-earring',
        'in-stock-ring',
        'in-stock-earring',
    ].includes(props?.currentMetal?.sub_type)) && props?.presetsubtype !== 'preset';
});

const showSolitaireNecklaceText = computed(() => {
    return props?.currentMetal?.sub_type && ['solitaire-necklace'].includes(props?.currentMetal?.sub_type);
});
const isRingType = computed(() => 
  props?.detailData?.sub_type === 'soiree-ring' || 
  props?.detailData?.sub_type === 'hues-ring' ||
  fancysubtypes === 'soiree-earring'
);
const isPreset = computed(() => {
    return props?.presetsubtype == 'preset' || props?.detailData?.sub_type === 'in-stock-ring' || props?.detailData?.subType === 'in-stock-ring';
});

const showIndiaEternityText = computed(() => {
    return $country?.is_india && props?.currentMetal?.sub_type === 'full-eternity-ring';
});

const showNonIndiaEternityText = computed(() => {
    return !$country?.is_india && props?.currentMetal?.sub_type === 'full-eternity-ring';
});

const showWeddingBandText = computed(() => {
    const detailSubType = props?.detailData?.sub_type || props?.detailData?.subType;
    return !(props?.currentMetal?.sub_type && ['full-eternity-ring', 'in-stock-ring', 'earring', 'pendant', 'tennis-bracelet', 'fashion-necklace', 'fashion-bracelet', 'stud-earring', 'hoop-earring',
        'tennis-necklace', 'solitaire-necklace','initial-necklace'].includes(props?.currentMetal?.sub_type))
        && props?.presetsubtype !== 'preset'
        && props?.moduleSubType !== 'ring'
        && detailSubType !== 'hues-ring'
        && detailSubType !== 'soiree-ring'
        && props?.moduleSubType !== 'earring'
        && props?.moduleSubType !== 'pendant'
        && route.meta.name !== 'cyo-complete-earring'
        && route.meta.name !== 'cyo-complete-pendant'
        && route.meta.name !== 'cyo-complete-ring';
});

const isHoopEarring = computed(() => {
    return props?.currentMetal?.sub_type === 'hoop-earring';
});
const resolvedQuantity = computed(() => {
    if (props?.addtionalAttirbute?.num_lots) {
        return props?.addtionalAttirbute?.num_lots || '';
    }
    if (props?.detailData?.sub_type === 'soiree-ring' && props?.item?.center_normal_stone_num_lots) {
        return props?.item.center_normal_stone_num_lots;
    }
    return props?.item?.side_stone?.diamonds || null;
});

const hues_shape = computed(() => {
    return props?.detailData?.sub_type === 'hues-ring';
});
const uniqueShapes = computed(() => {
  const shapes = [
    props?.item?.center_color_stone_shape,
    props?.item?.center_normal_stone_shape,
    props?.item?.side_normal_stone_shape,
  ].filter(value => value && value.trim()) // Ensure non-empty shapes
    .flatMap(shape => shape.split(/[\s,]+/)) // Split by commas or spaces
    .map(name => name.toLowerCase().replace(/[\s-]+/g, '').trim()) // Normalize shape names
    .filter((name, index, arr) => arr.indexOf(name) === index); // Remove duplicates

  return shapes;
});

onMounted(() => {
    sortImages();
    console.log('imageNames on mount:', imageNames.value);
});

</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
}

.img_box {
    height: 130px;
}
.hues_mew{
    text-transform: capitalize;
}
.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.text {
    font-size: 14px;
    font-style: italic;
    color: #909090;
}

.title_block {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    text-transform: capitalize;
}

p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}

.m-info {
    margin: 10px 0;
}

.title {
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}

@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    .text {
        font-size: 12px;
    }
}
</style>
